import { Flex } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface IconBadgeProps {
  children: ReactNode;
  size?: string;
}

const IconBadge = ({ children, size = "28px" }: IconBadgeProps) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    boxSize={size}
    bg="surface.hover"
    borderRadius="md"
    flexShrink={0}
  >
    {children}
  </Flex>
);

export default IconBadge;
